import {useEffect, useState} from "react";
import {MyUserQuery} from "../__generated__/generated_types";

interface BudgetYearStateProps {
    yearsListData: MyUserQuery | undefined;
    yearsListLoading: boolean;
}

function setBudetYearLocalStorage(year: number): void {
    localStorage.setItem("vizibly-budgetYear", year.toString());
}

function getBudetYearLocalStorage(): number | undefined {
    const val = localStorage.getItem("vizibly-budgetYear");
    if(val) {
        try {
            return parseInt(val, 10);
        } catch {
            /* SWALLOW */
        }
    }
    return undefined;
}

function clearBudetYearLocalStorage(): void {
    localStorage.removeItem("vizibly-budgetYear");
}

export function useBudgetYearState(props: BudgetYearStateProps) {
    const {yearsListData, yearsListLoading} = props;
    const [budgetYear, setBudgetYear] = useState<number | undefined>(getBudetYearLocalStorage());
    const [yearsList, setYearsList] = useState<number[]>([]);

    function doSetBudgetYear(year: number): void {
        setBudetYearLocalStorage(year);
        setBudgetYear(year);
    }

    function ensureBudgetYearIsValid(budgetYear: number, clientId: string): void {
        const clientYearsList = yearsListData?.listUserClients?.find(client => client.clientId === clientId);
        if(!clientYearsList) {
            return;
        }
        if(!clientYearsList.listBudgetYears.budgetYears.some(year => year.year === budgetYear)) {
            doSetBudgetYear(clientYearsList.listBudgetYears.activeBudgetYear);
        }
    }

    useEffect(() => {
        if(yearsListData && !yearsListLoading) {
            const years = yearsListData.listBudgetYears.budgetYears.map(year => year.year).sort((a, b) => b - a);
            setYearsList(years);

            let localYear = budgetYear;
            if(!localYear) {
                localYear = getBudetYearLocalStorage();
            }
            if(!localYear || !years.includes(localYear)) {
                doSetBudgetYear(yearsListData.listBudgetYears.activeBudgetYear);
            } else {
                doSetBudgetYear(localYear);
            }
        }
    }, [yearsListData, yearsListLoading]);

    return {budgetYear, setBudgetYear: doSetBudgetYear, clearStoredBudgetYear: clearBudetYearLocalStorage, yearsList, ensureBudgetYearIsValid};
}